<template>
  <b-modal :id="id" @close="clean" @hidden="clean" @ok="confirm" ok-title="Обновить" header-bg-variant="light" header-text-variant="info" ok-variant="info" size="lg">
    <template #modal-title>
      <b-link class="mr-2" :href="defectDojoUrl" target="_blank">
        <b-img src="/static/defect-dojo-favicon.ico" width="30" height="30"/>
      </b-link>
      Defect-Dojo
    </template>
    <div class="text-left mb-4">
      <b-form-checkbox switch v-model="sync" size="md">Синхронизация с Defect-Dojo. При завершении выполнения данные будут импортированы в Defect-Dojo</b-form-checkbox>
    </div>
    <b-row class="mt-3">
      <b-col>
        <label>Продукт</label>
        <div class="text-muted mb-5">
          <b-form-checkbox switch v-model="autoProduct" size="md">Создать новый продукт автоматически</b-form-checkbox>
        </div>
        <b-form v-if="!autoProduct">
          <b-form-group description="Id продукта">
            <b-form-input v-model="productId" :state="productIdState" type="number"/>
          </b-form-group>
        </b-form>
      </b-col>
      <b-col>
        <label>Обязательство</label>
        <div class="text-muted mb-3">
          <b-form-checkbox switch v-model="autoEngagement" size="md">Создать новое обязательство для каждой цели автоматически</b-form-checkbox>
          <b-form-checkbox switch v-if="!autoEngagement" v-model="newEngagement" size="md">Создать новое обязательство для всех целей</b-form-checkbox>
        </div>
        <b-form v-if="!autoEngagement && !newEngagement">
          <b-form-group description="Id обязательства">
            <b-form-input v-model="engagementId" :state="engagementIdState" type="number"/>
          </b-form-group>
        </b-form>
        <b-form v-if="!autoEngagement && newEngagement">
          <b-form-group class="mt-3" description="Название обязательства" :invalid-feedback="invalidName">
            <b-form-input type="text" v-model="engagementName" :state="nameState" maxlength="100"/>
          </b-form-group>
          <b-form-group description="Описание обязательства" :invalid-feedback="invalidDescription">
            <b-form-textarea v-model="engagementDescription" :state="descriptionState" rows="4" maxlength="300"/>
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import RekonoApi from '@/backend/RekonoApi'
export default {
  name: 'defectDojoModal',
  mixins: [RekonoApi],
  props: {
    id: String,
    project: Object,
    initialized: {
      type: Boolean,
      default: false
    }
  },
  data () {
    this.getSettings()
    return {
      sync: null,
      autoProduct: null,
      autoEngagement: null,
      newEngagement: null,
      productId: null,
      engagementId: null,
      engagementName: null,
      engagementDescription: null,
      productIdState: null,
      engagementIdState: null,
      nameState: null,
      descriptionState: null,
      invalidName: 'Название обязательства обязательно',
      invalidDescription: 'Описание обязательства обязательно',
    }
  },
  watch: {
    initialized (initialized) {
      if (initialized && this.project) {
        this.sync = this.project.defectdojo_synchronization
        this.autoProduct = false
        this.autoEngagement = this.project.defectdojo_engagement_by_target
        this.newEngagement = false
        this.productId = this.project.defectdojo_product_id
        this.engagementId = this.project.defectdojo_engagement_id
      }
    }
  },
  methods: {
    confirm (event) {
      event.preventDefault()
      if (this.check()) {
        let data = {}
        if (!this.autoProduct) {
          data.product_id = this.productId
        }
        if (!this.autoEngagement && !this.newEngagement) {
          data.engagement_id = this.engagementId
        } else if (!this.autoEngagement && this.newEngagement) {
          data.engagement_name = this.engagementName
          data.engagement_description = this.engagementDescription
        }
        this.put(`/api/projects/${this.project.id}/defect-dojo/`, data, 'Defect-Dojo', `Интеграция настроена успешно для ${this.project.name}`)
          .then(() => {
            const confirmation = { id: this.id, success: true, reload: true }
            if (this.sync !== this.project.defectdojo_synchronization) {
              this.put(`/api/projects/${this.project.id}/defect-dojo/sync/`, { synchronization: this.sync }, 'Defect-Dojo', this.sync ? 'Синхронизация включена' : 'Синхронизация отключена')
                .then(() => this.$emit('confirm', confirmation))
            } else {
              this.$emit('confirm', confirmation)
            }
          })
      }
    },
    check () {
      if (this.autoProduct) {
        this.productId = this.project.defectdojo_product_id
        this.productIdState = null
      } else {
        this.productIdState = (this.productId && this.productId > 0)
      }
      if (this.autoEngagement) {
        this.engagementId = this.project.defectdojo_engagement_id
        this.engagementName = null
        this.engagementDescription = null
        this.engagementIdState = null
        this.nameState = null
        this.descriptionState = null
      } else if (this.newEngagement) {
        this.engagementId = this.project.defectdojo_engagement_id
        this.engagementIdState = null
        this.nameState = this.validateName(this.engagementName)
        this.invalidName = this.engagementName && this.engagementName.length > 0 ? 'Неверное название обязательства' : 'Название обязательства обязательно'
        this.descriptionState = this.validateText(this.engagementDescription)
        this.invalidDescription = this.engagementDescription && this.engagementDescription.length > 0 ? 'Неверное описание обязательства' : 'Описание обязательства обязательно'
      } else {
        this.engagementIdState = (this.engagementId && this.engagementId > 0)
        this.nameState = null
        this.descriptionState = null
      }
      return this.productIdState !== false && this.engagementIdState !== false && this.nameState !== false && this.descriptionState !== false
    },
    clean () {
      this.sync = null
      this.autoProduct = null
      this.autoEngagement = null
      this.newEngagement = null
      this.productId = null
      this.engagementId = null
      this.engagementName = null
      this.engagementDescription = null
      this.productIdState = null
      this.engagementIdState = null
      this.nameState = null
      this.descriptionState = null
      this.$emit('clean')
    }
  }
}
</script>
